import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '../ui/Icon';
const benefits = ['Crear tu primer producto digital', 'Construir un negocio real desde cero', 'Vender usando IA sin experiencia previa', 'Dejar de perder tiempo probando métodos que no funcionan', 'Tener acceso a un sistema probado que ya generó millones'];
export function WhoThisIsFor() {
  return <section className="py-20 bg-white" data-id="element-300">
      <div className="max-w-4xl mx-auto px-6" data-id="element-301">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-302">
          <div className="inline-flex items-center gap-2 bg-black text-orange-400 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-4" data-id="element-303">
            <Icon name="users" size={18} data-id="element-304" />
            Para Quién Es Esto
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-black mb-4" data-id="element-305">
            ¿Para Quién Es Esto?
          </h2>
          <p className="text-xl text-gray-700" data-id="element-306">Para ti si quieres:</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-200 rounded-2xl p-8 md:p-12" data-id="element-307">
          <div className="space-y-4" data-id="element-308">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.3 + index * 0.05
          }} className="flex items-start gap-4 bg-white rounded-lg p-4 border border-gray-200" data-id="element-309">
                <div className="flex-shrink-0 w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center mt-0.5" data-id="element-310">
                  <Icon name="check" size={16} className="text-white" data-id="element-311" />
                </div>
                <p className="text-gray-800 font-medium text-lg leading-relaxed" data-id="element-312">
                  {benefit}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}